import React from 'react';

import './StatsGameScore.scss';

const StatsGameScore = ({ home, away }) => {
  return(
    <div className='stats-game-score'>
      <div className='stats-game-score__title'>
        <span className='stats-game-score__title__text'>HOME</span>
        <span className='stats-game-score__title__score'>{home}</span>
      </div>
      <div className='stats-game-score__title'>
        <span className='stats-game-score__title__text'>AWAY</span>
        <span className='stats-game-score__title__score'>{away}</span>
      </div>
    </div>
  );
};

export default StatsGameScore;
